import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';
import { lighten } from 'polished';

const StyledCard = styled(Card)`
  && {
    &.card-success {
      background-color: ${lighten(0.04, green[50])};
      box-shadow: 0 0 0 1px ${green[100]};
    }

    &.card-error {
      background-color: ${lighten(0.02, red[50])};
      box-shadow: 0 0 0 1px ${red[100]};
    }

    &.card-warning {
      background-color: ${lighten(0.04, orange[50])};
      box-shadow: 0 0 0 1px ${orange[100]};
    }
  }
`;

const CardWithStatus = ({ status, children, ...rest }) => (
  <StyledCard className={clsx(status && `card-${status}`)} {...rest}>
    {children}
  </StyledCard>
);

CardWithStatus.propTypes = {
  status: PropTypes.oneOf(['success', 'warning', 'error']),
  children: PropTypes.any.isRequired,
};

CardWithStatus.defaultProps = {
  status: undefined,
};

export default CardWithStatus;
